import React, { useState } from 'react'
import { BiChevronDown } from 'react-icons/bi'

const SearchBox = () => {
    const [searchInput, setSearchInput] = useState('')
    const [searchResult, setSearchResult] = useState('')
    const [serachType, setSearchType] = useState('Global Packages')
    const [searchTypeDrp, setSearchTypeDrp] = useState(false)
    const [loading, setLoading] = useState(false)
    const handleSearch = () => {
        if (searchInput.length > 3) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setSearchResult(searchInput)

            }, 1000);
        } else {
            setSearchResult('')
        }
    }
    return (
        <div className='mt-16'>
            <form className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row items-center sm:space-x-2 bg-transparent sm:bg-white p-2" onSubmit={(e) => { e.preventDefault(); handleSearch() }}>
                {/* search type section */}
                <div className='bg-gray-100  w-full  py-2 sm:py-0 sm:bg-white px-2 relative'>

                    <div className="flex sm:w-[10.5rem]  items-center space-x-2 cursor-pointer" onClick={() => setSearchTypeDrp(!searchTypeDrp)}>
                        <BiChevronDown className={`text-2xl transition duration-300 ${searchTypeDrp && 'transition duration-300 transform rotate-180'}`} />
                        <p>{serachType}</p>
                    </div>
                    {/* drop down section  */}
                    {searchTypeDrp && <div className="absolute animate-from-top bg-gray-100 sm:bg-white mt-3 sm:mt-6 -ml-2 sm:-ml-4 px-4 py-2 shadow-md w-full">
                        {serachType !== 'Global Packages' && <p className='py-1 cursor-pointer hover:text-primary-dark-600' onClick={() => { setSearchType('Global Packages'); setSearchTypeDrp(false) }}>Global Packages</p>}
                        {serachType !== 'Local Packages' && <p className='py-1 cursor-pointer hover:text-primary-dark-600' onClick={() => { setSearchType('Local Packages'); setSearchTypeDrp(false) }}>Local Packages</p>}
                        {serachType !== 'Blog' && <p className='py-1 cursor-pointer hover:text-primary-dark-600' onClick={() => { setSearchType('Blog'); setSearchTypeDrp(false) }}>Blog</p>}
                    </div>}

                </div>
                <p className='hidden sm:block h-6 w-[0.2rem] bg-gray-400'></p>
                {/* input section  */}
                <div>
                    <input type="text" name="" id="" className='sm:border-none sm:outline-none py-2 w-[80vw] sm:w-[22rem] lg:w-[28rem]' placeholder='Find Your Next Destination . . . . ' onChange={(e) => setSearchInput(e.target.value)} />
                </div>
                {/* search btn  */}
                <div className='w-full'>
                    <input type="submit" value={loading ? 'Loading' : 'Search'} className='bg-primary-base text-white py-2 w-24 cursor-pointer' />
                </div>
            </form>

            {/* search result card  */}
            {searchResult.length > 0 && <div className="bg-white mt-4 shadow-lg w-full p-4 max-h-44 xl:max-h-58 2xl:max-h-68 overflow-y-auto">
                <div className="flex items-center justify-between">
                    <p className="text-gray-700">Search Results</p>
                    <p className="text-sm text-gray-500">122 records</p>
                </div>
                <hr className="my-2" />
                {/* results  */}
                <div className="my-2 cursor-pointer">
                    <p className='py-2 hover:text-primary-base'>{searchResult}</p>
                    <p className='py-2 hover:text-primary-base'>{searchResult}</p>
                    <p className='py-2 hover:text-primary-base'>{searchResult}</p>
                    <p className='py-2 hover:text-primary-base'>{searchResult}</p>
                    <p className='py-2 hover:text-primary-base'>{searchResult}</p>
                    <p className='py-2 hover:text-primary-base'>{searchResult}</p>
                </div>
            </div>}
        </div>
    )
}

export default SearchBox